module.exports = __webpack_public_path__ + "img/5.e43dc38a.jpg";